import { createSelector } from 'reselect'

const getInfo = state => state.info

export const getData = createSelector(
  [getInfo],
  info => info.get('data')
)

export const getDownload = createSelector(
  [getData],
  data => {
    const acf = data && data.get('acf')
    const downloadTitle = acf && acf.get('download_title')
    const downloadFile = acf && acf.get('download_file')
    const downloadUrl = downloadFile && downloadFile.get('url')

    return {
      title: downloadTitle,
      url: downloadUrl
    }
  }
)

export const getDescription = createSelector(
  [getInfo, getData],
  (info, data) => {
    const acf = data && data.get('acf')
    const aboutText = acf && acf.get('about_text')
    const desc = aboutText || info.get('description')
    return desc
  }
)

export const getAddress = createSelector(
  [getInfo, getData],
  (info, data) => {
    const acf = data && data.get('acf')
    const address = acf && acf.get('address')

    return address ? address.map(loc => ({
      html: loc.get('info')
    })) : []
  }
)

export const getOk = createSelector(
  [getInfo],
  info => info.get('okText')
)

export const getSignupPlaceholder = createSelector(
  [getInfo],
  info => info.get('signupPlaceholder')
)

export const getThanks = createSelector(
  [getInfo],
  info => info.get('thanksText')
)



// WEBPACK FOOTER //
// ./src/components/info/selectors.js